<template>
<div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5">
  <loading v-if="loadingState" />
  <div class="container  mt-5 pt-4">

    <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div class="row justify-content-center text-left">
      <h3 class="Regular center h0 widthFull"><b>Documenti per cessionari finali  </b></h3>

      <div class="col-md-10 center mb-3">

        <h4 class="Regular text-left h0 widthFull ml-3"> Modifica Documento: <b> {{item.docName}} </b></h4>

        <p class="black mt-0 text-left widthFull ml-3">
          In questa pagina puoi eliminare i documenti caricati e aggiungerne di nuovi.
        </p>

      </div>
      <div class="col-md-2 pt-4 center mb-3 text-right">
        <router-link :to="{ name: 'flowSettings' }" class="btn btn-primary m-2 btn-sm ml-md-5">
          <font-awesome-icon icon="arrow-left" size="1x" />
          Indietro
        </router-link>
      </div>
    </div>

    <form class="pb-5 pt-3 black widthFull vaillantCont" id="doc-form">

      <div class="row justify-content-center text-left pl-4 pr-4">

        <div class="col-md-8 center mb-3">
          <div class="row justify-content-center text-left">

            <div class="col-md-12 center mb-3">
              <h5 class="Regular"><b>File caricati</b></h5>
            </div>
            <div v-for="(url, key, index) in dbdoc.images" :key="index" class="col-6 col-md-4 center mb-5">

              <p class="pb-1 mb-1">File {{index + 1}} </p>

              <viewer class=" clearfix widthFull" @inited="inited" :ref="'viewer' + key">
                <img :src="url" :key="key" class="img-fluid editImageCont">
              </viewer>

              <button class="btn btn-primary btn-xl mt-3" v-on:click="show(key)" type="button">
                <font-awesome-icon icon="eye" size="sm" /> Visualizza
              </button>

              <button class="btn btn-danger btn-xl  mt-3" v-on:click="removeDocument(docIndex, doc.name, doc.codice, key, index)" type="button">
                <font-awesome-icon icon="trash-alt" size="sm" /> Elimina
              </button>

            </div>



          </div>

        </div>

        <div class="col-md-4 center mb-3 even">
          <div class="row justify-content-center text-left">
            <div class="col-md-12 center mb-3">
              <h5 class="Regular"><b>Carica nuovo File</b></h5>

              <div class="front-image">

                <input type="file" v-on:change="uploadFile(docIndex, doc.name, doc.codice, dbdoc.completed)" :ref="'fileInput' + docIndex" name="invoiceFront" id="invoiceFront" class="fileInput" data-vv-as="Logo"
                  v-validate="{required:false,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                  :class="{ 'is-invalid': errors.has('invoiceFront'), valid: !!invoiceFront, helper: !!invoiceFrontBucket }">

                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel labelFileInput" for="invoiceFront">

                  <span v-if="!invoiceFrontName" class="smallText center white" :style="{ backgroundImage: 'url(' + invoiceFrontBucket + ')' }">
                    <p v-if="!invoiceFrontName" class="smallText center white mt-3 mb-0 pb-0">Scegli il Contratto quadro*</p>
                  </span>

                  <span v-else class="smallText center white" :style="{  backgroundImage: 'url(' + invoiceFrontBucket + ')' }">

                  </span>

                </label>

                <div v-if="errors.has('invoiceFront')" class="invalid-feedback">
                  {{ errors.first('invoiceFront') }}
                </div>

                <div v-if="dbdoc.percent" class="progress mt-5" id="progFront">
                  <div class="progress-bar " id="progress-bar-front" role="progressbar" v-bind:style="{width: dbdoc.percent + '%'}" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                    {{ dbdoc.percent }} %
                  </div>
                </div>

                <p v-if="invoiceFrontName" class="smallText center white mt-3 mb-0 pb-0 fileNameText">{{invoiceFrontName}}</p>

              </div>



            </div>

            <div class="col-md-6 center mt-5 mb-3">
              <small>
                Il documento può essere caricato nei formati jpeg, pdf, png, jpg (max 10MB)
              </small>
            </div>
          </div>
        </div>

      </div>

    </form>

  </div>

</div>

</div>
</template>

<script>
import {
  AUTH_REQUEST,
  AUTH_SOCIAL
} from 'actions/auth'
import {
  mapGetters,
  mapState
} from 'vuex'
import axios from 'axios'
import 'viewerjs/dist/viewer.css'

import Vue from 'vue'

const moment = require('moment')

const viewer = require('v-viewer')

export default {
  name: 'loadDocuments',
  components: {

  },
  data() {
    return {
      token: '',
      loadingState: false,
      loading: false,
      practices: {},
      moment: require('moment'),
      item: false,
      email: '',
      codice_fiscale: '',
      partita_iva: '',
      phone: '',
      cellulare: '',
      address: '',
      civic: '',
      region: '',
      province: '',
      city: '',
      zip: '',
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: 0,
      client_ownership: '',
      subalterno: '',
      particella: '',
      savedDocuments: {},
      foglio: '',
      item: '',
      dbdoc: '',
      doc: '',
      docIndex: '',
    }

  },
  methods: {
    inited(viewer) {
      var _vue = this
      this.$viewer = viewer
      console.log(viewer)

      console.log("ZOOOOOM")

      setTimeout(function() {
        _vue.$viewer.zoom(1)
      }, 1000)
    },
    show(index) {
      console.log(this)
      var el = this.$refs['viewer' + index]

      console.log(this.$refs)

      console.log(el[0])

      //const viewerV = el.$viewer

      el[0].destroyViewer()

      el[0].createViewer()

      el[0].$viewer.show()
      //viewer.zoomTo(2)
      //	viewer.move(-1, 0);
    },

    showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
      });
    },
    removeDocument(docIndex, name, codice, id, index) {


      var _vue = this

      this.$swal({
        title: 'Attenzione!',
        type: 'warning',
        html: '<br/>Sei sicuro di voler eliminare File ' + index + ' del documento ' + name + ' ?<br/><br/>',
        showCancelButton: true,
        confirmButtonText: `SI`,
        cancelButtonText: `NO`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        console.log(result)
        if (result.value) {
          this.loadingState = true
          axios({
              url: process.env.ROOT_API + 'api/removeDocumentCdpAccess',
              method: 'POST',
              data: {
                docIndex: docIndex,
                code: _vue.getProfile.userToken,
                name: name,
                codice: codice,
                id: id
              },
              headers: {
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
                'Content-type': 'application/json'
              }
            })
            .then(resp => {
              console.log(1)
              this.loadingState = false
              var obj = _vue.dbdoc['images']

              for (var x in obj) {
                if (x == id) {
                  delete obj[x];
                  delete _vue.dbdoc['images'][x];
                }
              }

              _vue.dbdoc['countImages'] = _vue.dbdoc['countImages'] - 1


            })
            .catch(resp => {

              this.loadingState = false

            })


        }
      })




    },
    uploadFile(doc, name, docCode, completed) {

      console.log(this.$refs['fileInput' + doc])
      var input = this.$refs['fileInput' + doc]

      console.log(input)

      console.log(doc)
      console.log(name)
      console.log(docCode)

      var ind = doc
      console.log(0)
      var file = input.files[0].name
      this.invoiceFrontName = file
      var extension = file.substr((file.lastIndexOf('.') + 1)).toLowerCase()
      var size = input.files[0].size
      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.files[0].name
        var formData = new FormData();
        var _vue = this // << here
        formData.append('fattura0', input.files[0]);


        console.log(this.uploadFrontPercentage)

        formData.append('doc', doc);
        formData.append('code', this.getProfile.userToken);
        formData.append('name', name);
        formData.append('docCode', docCode);
        formData.append('completed', completed);

        console.log(1)

        axios.post(process.env.ROOT_API + 'api/uploadDocumentCdpAccess',
            formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              },
              onUploadProgress: function(progressEvent) {

                var r = 0
                r = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                //  Object.assign(this.uploadFrontPercentage, r)

                Vue.set(this.dbdoc, 'percent', r)


                //  this.uploadFrontPercentage[ind]['percent'] = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));

              }.bind(this)
            }
          ).then(function(e) {
            console.log(2)
            var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
            if (regex.test(e.data.document)) {
              _vue.dbdoc['percent'] = 0

              var x = _vue.dbdoc['images']

              x[e.data.id] = e.data.document

              _vue.dbdoc['images'] = x

              _vue.dbdoc['countImages'] = _vue.dbdoc['countImages'] + 1


              //_vue.invoiceFrontBucket = e.data.fattura
            } else {
              _vue.dbdoc['percent'] = 0
              //_vue.invoiceFront = ''
              //_vue.invoiceFrontBucket = ''

              //input.value = null
            }

            _vue.getDocuments( _vue.getProfile.userToken )

          })
          .catch(function() {
            _vue.dbdoc['percent'] = 0
            //  _vue.invoiceFront = ''
            ///  _vue.invoiceFrontBucket = ''

            //input.value = null

          });
      }

    },

    async getDocuments(user_token) {

      await axios({
        url: process.env.ROOT_API + 'api/getDocumentsCdpAccess',
        method: 'POST',
        data: {
          user_token: user_token
        },
        headers: {
          'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
          'Content-type': 'application/json'
        }
      })
      .then(resp => {

        //console.log( resp.data.documents )
        var docs = resp.data.documents
        this.dbdoc.images = {}
        var y = 0
        for( var x in docs ){
          if( docs[x].codice == this.docIndex  ){
            this.dbdoc.images[docs[x].id] = docs[x].url
            this.dbdoc.countImages = this.dbdoc.countImages + 1
            y = y + 1
          }
        }

        //console.log( this.dbdoc )
        //console.log( this.doc )
        //console.log( this.docIndex )

      })
      .catch(resp => {
        //this.savedDocuments = {}
      })

    },

  },
  watch: {

  },
  async created() {

  },
  mounted() {
    console.log(this.$route.params)

    if (this.$route.params.docIndex) {
      this.item = this.$route.params

      this.dbdoc = this.$route.params.dbdoc
      this.doc = this.$route.params.doc
      this.docIndex = this.$route.params.docIndex


    } else {
      this.$router.push('/flowSettings')
    }

    this.$scrollTo('#app', 700, {offset: -75})


  },
  computed: {
    ...mapGetters(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    })
  },
}
</script>

<style lang="scss" scoped>
$phone: 667px;
$tablet: 1024px;
$desktop: 1324px;
$lgscreen: 1524px;

.fileNameText {
    position: absolute;
    bottom: -37px;
    font-size: 17px;
    width: 100%;
    text-align: center;
    color: #0e3d8b!important;
    z-index: 12313;
    white-space: nowrap;
    word-wrap: break-word;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.borderTop {
    border-top: 3px solid #003d13;
    padding-top: 15px;
}

.shopIcon {
    width: 75px;
}

.bigTitle {
    font-size: 47px;
    color: #003d13;

    @media screen and (max-width: $phone) {
        font-size: 27px;
    }

}

.hideFileUpload {
    position: absolute;
    width: 100%;
    height: 110%;
    background: #000000;
    opacity: 0.4;
    top: -18px;
    left: 0;
    filter: blur(24px);
    z-index: 10000;
}

h5 {

    @media screen and (max-width: $phone) {
        font-size: 14px;
    }

}
.corporateImg {
    max-height: 153px;
}
.backImageInvoice {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    text-align: center;
    > img {
        max-height: 477px;
        margin: 0 auto;
        cursor: pointer;
    }
}

.zoomImage {
    position: absolute;
    left: 48%;
    top: 230px;
    cursor: pointer;
}

.vcenter {
    align-items: center;
    align-self: center;
    vertical-align: middle;
    display: inherit;
}

.front-image {

    position: relative;
    margin: 0 auto;
    display: block;
    height: 147px;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    width: 191px;
    margin-bottom: 17px;

    @media screen and (max-width: $tablet) {
        margin-top: 15px!important;
    }

    > .fileInputLabel {
        display: none;
    }

    > .invalid-feedback {
        display: block;
        position: absolute;
        bottom: 15px;
        font-weight: 800;
    }

    > input {
        position: absolute;
        filter: alpha(opacity=0);
        opacity: 0;
        left: 5px;
        width: 100%;
        height: 200px;
        z-index: 10;
        top: -20px;
    }

    > label {
        /*display: none;*/

        width: 100%;
        margin: 0 auto;
        text-align: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-item-align: center;
        align-self: center;
        position: relative;
        padding: 0!important !important;
        left: 0;

        > span {
            background-color: transparent;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            border: none;
            width: 192px;
            margin-top: 19px !important;
            display: block;
            height: 155px;
            margin: 0 auto;
            cursor: pointer;
            word-break: break-all;
            padding: 5px;
            color: white;
            border-radius: 7px;
            overflow-wrap: break-word;
            white-space: normal;
            line-height: 29px;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            align-self: center;
            vertical-align: middle;
            margin: auto;
            display: inline-grid;
            background-size: cover;
            background-position: center;

            &:before {
                content: "+";
                display: block;
                clear: both;
                text-align: center;
                height: 141px;
                width: 179px;
                border-radius: 7px;
                padding-top: 51px;
                font-size: 51px;
                font-weight: 600;
                color: #00917e;
                border: 3px solid #00917e;
            }

            @media screen and (max-width: $phone) {
                margin: 0 auto!important !important;
                float: none;
            }
            @media screen and (min-width: $phone) and (max-width: $tablet) {
                margin: 0 auto!important !important;
                float: none;
            }

        }

        &:after {
            content: "";
            display: block;

            clear: both;
            text-align: center;
            width: 237px;
            font-size: 10px;
            text-decoration: underline;
            color: black;

            /*
      display: block;
clear: both;
text-align: center;
height: 188px;
width: 188px;
border-radius: 7px;
font-size: 10px;
text-decoration: underline;
color: black;
border: 3px solid #0e3d8b;*/

            @media screen and (max-width: $phone) {
                margin: 0 auto!important !important;
                float: none;
            }
            @media screen and (min-width: $phone) and (max-width: $tablet) {
                margin: 0 auto!important !important;
                float: none;
            }

        }

        @media screen and (max-width: $phone) {
            width: 100%!important;
            float: none!important;
            text-align: center!important;
            margin: 0 auto!important !important;
        }
        @media screen and (min-width: $phone) and (max-width: $tablet) {
            width: 100%!important;
            float: none!important;
            text-align: center!important;
            margin: 0 auto!important !important;
        }

    }

}

.front-image2 {

    position: relative;
    margin: 0 auto;
    display: block;
    height: 29px;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    width: 100%;
    margin-bottom: 0;
    background: #00897e!important;
    color: white;
    border-radius: 5px;
    overflow: hidden;
    cursor: pointer;

    @media screen and (max-width: $tablet) {
        margin-top: 15px!important;
    }

    > .fileInputLabel {
        display: none;
    }

    > .invalid-feedback {
        display: block;
        position: absolute;
        bottom: 15px;
        font-weight: 800;
    }

    > input {
        position: absolute;
        filter: alpha(opacity=0);
        opacity: 0;
        left: 5px;
        width: 100%;
        height: 30px;
        z-index: 10;
        top: 0;

        cursor: pointer!important;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 99;
        /*This makes the button huge. If you want a bigger button, increase the font size*/
        font-size: 50px;
        /*Opacity settings for all browsers*/
        opacity: 0;
        -moz-opacity: 0;
        filter:progid:DXImageTransform.Microsoft.Alpha(opacity=0);

    }

    > label {
        /*display: none;*/
        cursor: pointer;
        width: 100%;
        margin: 0 auto;
        text-align: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-item-align: center;
        align-self: center;
        position: relative;
        padding: 0!important !important;
        left: 0;

        > span {
            background-color: transparent;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            border: none;
            width: 100%;
            margin-top: 0 !important;
            display: block;
            height: 29px;
            margin: 0 auto;
            cursor: pointer;
            word-break: break-all;
            padding: 0;
            color: white;
            border-radius: 7px;
            overflow-wrap: break-word;
            white-space: normal;
            line-height: 19px;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            align-self: center;
            vertical-align: middle;
            margin: auto;
            display: inline-grid;
            background-size: cover;
            background-position: center;
            cursor: pointer;
            &:before {
                cursor: pointer;
                content: "CARICA";
                font-family: Regular;
                font-weight: 300!important;
                display: block;
                clear: both;
                text-align: center;
                height: 29px;
                width: 100%;
                border-radius: 7px;
                padding-top: 3px;
                font-size: 0.775rem !important;
                font-weight: 600;
                color: white;
                border: 3px solid #00917e;
                /*padding: .55rem .55rem !important;*/
                font-size: 0.775rem !important;
                line-height: 0.9 !important;
                border-radius: 0.1rem !important;
            }

            @media screen and (max-width: $phone) {
                margin: 0 auto!important !important;
                float: none;
            }
            @media screen and (min-width: $phone) and (max-width: $tablet) {
                margin: 0 auto!important !important;
                float: none;
            }

        }

        &:after {
            content: "";
            display: block;

            clear: both;
            text-align: center;
            width: 100%;
            font-size: 10px;
            text-decoration: underline;
            color: black;
            cursor: pointer;
            /*
      display: block;
clear: both;
text-align: center;
height: 188px;
width: 188px;
border-radius: 7px;
font-size: 10px;
text-decoration: underline;
color: black;
border: 3px solid #0e3d8b;*/

            @media screen and (max-width: $phone) {
                margin: 0 auto!important !important;
                float: none;
            }
            @media screen and (min-width: $phone) and (max-width: $tablet) {
                margin: 0 auto!important !important;
                float: none;
            }

        }

        @media screen and (max-width: $phone) {
            width: 100%!important;
            float: none!important;
            text-align: center!important;
            margin: 0 auto!important !important;
        }
        @media screen and (min-width: $phone) and (max-width: $tablet) {
            width: 100%!important;
            float: none!important;
            text-align: center!important;
            margin: 0 auto!important !important;
        }

    }

}

.niceInputLabel2 {
    color: #ffffff !important;
    font-size: 21px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 0;
    top: 0;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
    white-space: nowrap;
    overflow: hidden;
    padding-right: 0;
    text-overflow: ellipsis;
    max-width: 100%;
}

.center-container {
    display: flex;
    align-items: center;
    flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/flowSettings/editDocumentCDP.vue